import { observable, computed, action, makeObservable } from 'mobx';

class SaleStore {
    isOpen;
    sale;
    invoice;
    saleId;
    selectedTab;
    prevSales;
    isProjectExist;
    isSaleDoneOpen;
    isInvoiceOpen;

    constructor() {
        


        this.isOpen = false;
        this.selectedTab = 0;
        this.sale = {};
        this.invoice = {};
        this.prevSales = [];
        this.prevInvoices = [];
        this.isSaleDoneOpen = false;
        this.isInvoiceOpen = false;
        this.isProjectExist = false;
        this.saleId = '';

        makeObservable(this, {
            isOpen: observable,
            isInvoiceOpen: observable,
            sale: observable,
            invoice: observable,
            isProjectExist: observable,
            saleId: observable,
            isSaleDoneOpen: observable,
            selectedTab: observable,
            isSaleDialogOpen: computed,
            isSaleDoneDialogOpen: computed,
            getIsProjectExist: computed,
            getSelectedTab: computed,
            getSale: computed,
            closeSaleDialog: action,
            openSaleDialog: action,
            openInvoiceDialog: action,
            setSelectedTab: action,
            setSale: action,
            setInvoice: action,
            openSaleFinishDialog: action,
            closeSaleFinishDialog: action,
            closeInvoiceDialog: action,
        });
    }

    get isSaleDialogOpen() {
        return this.isOpen;
    }

    get getSale() {
        return this.sale;
    }

    get getInvoice() {
        return this.invoice;
    }

    get getSelectedTab() {
        return this.selectedTab;
    }

    get getIsProjectExist() {
        return this.isProjectExist;
    }

    get isSaleDoneDialogOpen() {
        return this.isSaleDoneOpen;
    }

    setSale(sale) {
        this.sale = sale;
    }

    setInvoice(invoice) {
        this.invoice = invoice;
    }

    setSelectedTab(selectedTab) {
        this.selectedTab = selectedTab;
    }

    openSaleDialog(sale) {
        if (this.sale.id) {
            this.prevSales.push(this.sale);
        }
        this.sale = sale;
        this.isOpen = true;
        this.selectedTab = 0;
    }

    openInvoiceDialog(invoice) {
        if (this.invoice.id) {
            this.prevInvoices.push(this.invoice);
        }
        this.invoice = invoice;
        this.isInvoiceOpen = true;
        this.selectedTab = 0;
    }

    openSaleFinishDialog(id, isProjectExist) {
        this.saleId = id;
        this.isSaleDoneOpen = true;
        this.isProjectExist = isProjectExist;
    }

    closeSaleFinishDialog() {
        this.saleId = null;
        this.isSaleDoneOpen = false;
    }

    closeSaleDialog() {
        
        if (this.prevSales.length > 0) {
            this.sale = this.prevSales.pop();
        }
        else {
            this.sale = {};
            this.isOpen = false;
        }
    }

    closeInvoiceDialog() {

        if (this.prevInvoices.length > 0) {
            this.invoice = this.prevInvoices.pop();
        }
        else {
            this.invoice = {};
            this.isInvoiceOpen = false;
        }
    }
}

const saleStore = new SaleStore();

export default saleStore;
export { SaleStore };